import { render } from "./UploadBio.vue?vue&type=template&id=2f51db20"
import script from "./UploadBio.vue?vue&type=script&lang=js"
export * from "./UploadBio.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__